import React from "react"
import { Link as GatsbyLink } from "gatsby"
import {
  Box,
  Container,
  makeStyles,
  Grid,
  Link,
  Typography,
} from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  footer: {
    marginTop: 64,
    background: theme.palette.common.neutral,
    borderTop: `1px solid ${theme.palette.border}`,
  },
  footerList: {
    listStyle: "none",
    paddingLeft: 0,
  },
  footerLink: {
    marginBottom: theme.spacing(2),
  },
  primaryFooterLink: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
  },
  secondaryFooterLink: {
    color: theme.palette.text.secondary,
  },
}))

const primaryLinks = [
  {
    label: "Home",
    to: "/",
  },
  {
    label: "Features",
    to: "/features",
  },
  {
    label: "Pricing",
    to: "/pricing",
  },
  {
    label: "Support",
    to: "https://kovalt.freshdesk.com",
    rel: "nofollow noopen",
    target: "_blank",
  },
]

const secondaryLinks = [
  {
    label: "Contact Us",
    to: "/contact",
  },
  {
    label: "Terms of Service",
    to: "/terms-of-service",
  },
  {
    label: "Privacy Policy",
    to: "/privacy-policy",
  },
]

const Footer = () => {
  const classes = useStyles()

  return (
    <Box component="footer" className={classes.footer} padding={4}>
      <Container maxWidth="md">
        <Grid container>
          <Grid item xs={12} sm={3}>
            <Box>
              <img
                style={{ display: "block", maxWidth: 100 }}
                src="/kovalt_logos/kovalt_square_violet_no_bg.svg"
                alt="Small logo"
              />
              <Typography variant="caption">
                <Link href="https://mark.janiczak.me" target="_blank">
                  Made in Brisbane, Australia
                </Link>
                <br />
                <Link href="emailto:hello@kovalt.io">hello@kovalt.io</Link>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <ul className={classes.footerList}>
              {primaryLinks.map(({ label, to, ...other }, i) => (
                <li key={i} className={classes.footerLink}>
                  <Link component={GatsbyLink} to={to} {...other}>
                    <Typography
                      variant="subtitle1"
                      className={classes.primaryFooterLink}
                    >
                      {label}
                    </Typography>
                  </Link>
                </li>
              ))}
            </ul>
          </Grid>
          <Grid item xs={12} sm={3}>
            <ul className={classes.footerList}>
              {secondaryLinks.map(({ label, to, ...other }, i) => (
                <li key={i} className={classes.footerLink}>
                  <Link component={GatsbyLink} to={to} {...other}>
                    <Typography
                      variant="subtitle2"
                      className={classes.secondaryFooterLink}
                    >
                      {label}
                    </Typography>
                  </Link>
                </li>
              ))}
            </ul>
          </Grid>
        </Grid>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={2}
        >
          <Typography variant="caption">
            Copyright {new Date().getFullYear()} Kovalt
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
